module.exports = __webpack_public_path__ + "static/media/MIAB9441-180730-60_Small.ca5e0f31.jpg";